import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Observer} from "rxjs";
import {ModalConfig} from "../notification/modal.config";
import {NetworkService} from "../interaction/network.service";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";
import {BrowserAgent} from "../browser/browser.agent";
import {AudioContextWrapper} from "./audiocontextwrapper.service";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class AudioPlaybackService {

    private player: AudioContextWrapper;
    /*
     This class is meant to be a wrapper around the audio library.
     At least until there is a reason, please do not use this class directly.  Go through the audioqueueservice.
     */
    constructor(private modalConfig: ModalConfig,
                private networkService: NetworkService,
                private browserAgent: BrowserAgent,
                private http: HttpClient,
                private log: BugsnagLoggingService) {
        this.player = new AudioContextWrapper(this.http, this.log);
    }

    private play(): void {
        this.player.play();
    }

    playSequence(audioPath: string, callback?: Function, errorCallback?: Function, playingCallback?: Function): void {
        this.doSetupPlayer(audioPath, callback, errorCallback, playingCallback);

        if (this.networkService.isOnline()) {
            this.play();
        } else {
            this.modalConfig.openMessageModal("disconnect_network_error");
            this.hardCancel();
        }
    }

    private doSetupPlayer(audioPath: string, callback?: Function, errorCallback?: Function,
                          playingCallback?: Function): void {
        this.player.src = audioPath;

        // add some event listeners to the player
        this.player.addEventListener("pause", () => this.handlePauseEvent(), true);
        this.player.addEventListener("ended", () => this.handleEndedEvent(callback), true);
        this.player.addEventListener("error", (e: ErrorEvent) => this.handleErrorState(e, errorCallback), true);
        this.player.addEventListener("play", () => this.handlePlayState(playingCallback), true);
    }

    isAudioPlayerPlaying(): boolean {
        let isPlaying = false;
        if (this.player) {
            isPlaying =
                this.player.isPlaying();
        }
        return isPlaying;
    }

    isAudioPlayerInitiated(): boolean {
        return this.player.playEventStarted || this.isAudioPlayerPlaying();
    }

    cancel(): Observable<boolean> {
        return this.resetPlayer();
    }

    hardCancel(): void {
        this.player.pause().subscribe();
        this.player.playEventStarted = false;
        this.player.removeEventListener("ended", () => {});
        this.player.removeEventListener("error", () => {});
        this.player.removeEventListener("play", () => {});
    }

    resetPlayer(): Observable<boolean> {
        if (this.isAudioPlayerInitiated()) {
            return this.player.pause();
        } else {
            return Observable.create((observer: Observer<boolean>) => {
                observer.next(true);
                observer.complete();
            });
        }
    }

    handlePauseEvent(): void {
        this.log.log("The player is in a pause state: " + this.player.src);
    }

    handlePlayState(playingCallback: Function): void {
        this.log.log("The player is in a playing state: " + this.player.src);
        if (playingCallback) {
            playingCallback();
        }
    }

    handleEndedEvent(successCallback: Function): void {
        this.log.log("The player is in an ended state. " + this.player.src + "have callback:" + !!successCallback);
        if (successCallback) {
            this.log.log("calling success callback in handle ended event: " + successCallback.toString());
            successCallback();
        }
    }

    handleErrorState(e: ErrorEvent, errorCallback: Function): void {
        if (errorCallback) {
            errorCallback(e);
        } else {
            this.log.log("no audio available");
            this.modalConfig.openMessageModal("disconnect_network_error");
        }
    }

}
